import { NpaReportActionDispatch, NpaReportReduxTypes } from "./types";

export const createNpaReport = (payload:any):NpaReportActionDispatch =>({
    type:NpaReportReduxTypes.NPA_REPORT,
    payload:payload
})